import { SelectBase } from "@shared/ui/SelectBase";
import { TimezoneOption } from "@platform/features/timezones/timezones.types";

export type Props = {
  options: TimezoneOption[];
  value: string;
  onChange: (val: TimezoneOption | null) => void;
};

export function SchedulingTimezoneSelect({ options, value, onChange }: Props) {
  const onBlur = () => {
    setTimeout(() => {
      // Create a fake nudge that forces layout shift to reset the zoom
      const scrollY = window.scrollY;
      window.scrollTo(0, scrollY + 1);
      window.scrollTo(0, scrollY);
    }, 0);
  };

  return (
    <SelectBase
      name="timezone"
      value={options.find((option) => option.value === value) || null}
      onSelect={(val) => onChange(val as TimezoneOption | null)}
      className="w-full"
      options={options}
      onBlur={onBlur}
    />
  );
}

export default SchedulingTimezoneSelect;
